import { useEffect, useState } from 'react';

/**
 * The useWineClasses hook provides classes for the wine cards.
 * @param showEurPrice - A boolean value that determines whether to show the price in EUR.
 * @returns an object with the following properties and methods:
 */

export const useWineClasses = (showEurPrice: boolean) => {
  // The slideUpDivClasses is the classname for the wine card the contains the cart animation.
  const slideUpDivClasses =
    'w-full flex min-[350px]:transform-none lg:transform lg:absolute lg:bottom-20 lg:left-0 lg:px-3 lg:backdrop-blur-md flex flex-col bg-[#F6F5F2] bg-opacity-30 lg:transition-transform duration-300 ease-in-out';

  // The classnameWithCart and classnameWithoutCart are used to determine the position of the cart section on the wine card.
  const [classnameWithCart, setClassnameWithCart] = useState('');
  const [classnameWithoutCart, setClassnameWithoutCart] = useState('');

  useEffect(() => {
    const classnameWithCart = showEurPrice ? 'lg:translate-y-[75px]' : 'lg:translate-y-[60px]';
    const classnameWithoutCart = showEurPrice ? 'lg:translate-y-[160px]' : 'lg:translate-y-[140px]';
    setClassnameWithCart(classnameWithCart);
    setClassnameWithoutCart(classnameWithoutCart);
  }, [showEurPrice]);

  return { slideUpDivClasses, classnameWithCart, classnameWithoutCart };
};
